import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Subscribe } from "unstated";
import {
  callReduxAlertAction,
  callReduxConfirmAlertAction,
  globalVars
} from "../../App";
import { hideConfirmAlertAction } from "../../redux/actions/alertConfirmAction";
import { store as reduxStore } from "../../redux/store";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import myGlobals from "../../Utils/globals";
import myUtilities from "../../Utils/utils";
import { StaticInput, MarketingText } from "../Common";
import AlertConfirmDialog from "../Common/AlertConfirmDialog";
import Alert from "react-bootstrap/Alert";

class TopBuildPaymentOnAccountForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fields: null,
      showAlert: false,
      okPressed: false,
    };
    this.invoiceData = null;
  }

  dynamicFieldsResponseHandler = (data) => {
    if (data.fields !== undefined && data.fields !== null) {
      this.setState({
        fields: data.fields,
      });
    }
  };

  getDynamicFieldData = (invData, onSuccess) => {
    const searchParams = new URLSearchParams();
    searchParams.append("globalAccountId", invData.state.globalAccountId);

    let link = "getRemittanceFormElements"; // API Modular
    link = myGlobals.initialHost + myGlobals.appender + link;
    // link = "https://api.jsonbin.io/b/5e8ef948172eb6438960c3b7";
    fetch(link, {
      //https://api.jsonbin.io/b/5e8ef948172eb6438960c3b7/1
      //'https://api.myjson.com/bins/xg2c6'

      method: 'POST',
      body: searchParams

      // method: "GET",
      // headers: {
      //   //poa
      //   "secret-key":
      //     "$2b$10$V7Yj/PzFJS.MX80bYHIji.ocR9meNY9i6gHR6YjKjZkl9Qn8wGA9a",
      // },
    })
      .then(function (response) {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }
        //console.log(response.text());
        return response.json();
      })
      .then(function (data) {
        onSuccess(data);
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
        callReduxAlertAction(
          "failure.generic.remittance.alert",
          "Validations failed, please enter correct data"
        );
      });
  };

  dynamicForm = () => {
    if (this.state.fields === null || this.state.fields === undefined) {
      return null;
    } else {
      let fields = this.state.fields;
      let inputs = [];
      for (let i = 0; i < fields.length; ++i) {
        let isNumber = undefined;
        let showDropDown = undefined;
        let isRequired = undefined;
        if (fields[i].type !== undefined &&
          fields[i].type !== null &&
          fields[i].type.toString().localeCompare("number") === 0
        )
          isNumber = true;
        if (
          fields[i].showDropDown !== undefined &&
          fields[i].showDropDown !== null &&
          fields[i].showDropDown.toString().localeCompare("true") === 0
        )
          showDropDown = true;
        if (
          fields[i].required !== undefined &&
          fields[i].required !== null &&
          fields[i].required.toString().localeCompare("true") === 0
        )
          isRequired = true;
        inputs.push(
          <StaticInput
            isRequired={isRequired}
            key={fields[i].name}
            isNumber={isNumber}
            isDropdownField={fields[i].isDropdownField}
            dropDownValues={fields[i].dropDownValues}
            showDropDown={showDropDown}
            formSetState={this.formSetState}
            className="topbuild-row-margin-top"
            name={fields[i].name}
            label={myUtilities.accountSpecificLanguage(
              "dynamicform." + fields[i].name,
              fields[i].displayName
            )}
          />
        );
      }
      return inputs;
    }
  };
  formSetState = (index, data) => {
    let obj = "{" + '"' + index + '"' + ":" + '"' + data + '"' + "}";
    this.setState(JSON.parse(obj));
  };

  alertContent = () => {
    if (this.state.showAlert) {
      return (
        <Alert className="my-alert-class" variant="danger">
          <p>
            {myUtilities.accountSpecificLanguage("Validation.invalidEmailId", "Please provide a valid Email Id")}
          </p>
        </Alert>
      );
    }
  };
  responseHandler = async (data, invdata) => {
    if (!data.rows.isValidEmailId) {
      this.setState({
        showAlert: true,
      });
      setTimeout(() => {
        this.setState({
          showAlert: false,
        });
      }, 3000);
    }
    if (!this.callDone) {
      globalVars.isTopBuild = true;
      globalVars.paymentCardKeyCount = new Set();
      globalVars.selectedCard = -1;
      await invdata.populateData(data);
      myGlobals.topBuildResponse = data;
      myGlobals.paymentLimitsMap = data.rows.paymentLimits;
      console.log('value of map');
      console.log(myGlobals.paymentLimitsMap);
      this.props.history.replace(`/mainapp`);
      this.callDone = true;
      this.updateGuestLoginStatus();
    }
  };
  updateGuestLoginStatus = () => {
    const searchParams = new URLSearchParams();
    searchParams.append("token", myGlobals.token);
    let link = "updateGuestLoginHistoryStatus";
    link = myGlobals.initialHost + myGlobals.appender + link;
    fetch(link, {
      method: "POST",
      body: searchParams,
    })
      .then(function (response) {
        if (response.status !== 200) {
          return;
        }
        return response.json();
      })
      .catch(function (err) {});
  };

  onSubmit = (invData, onSuccess) => {
    console.log(this.state)
    let isOkPressed = this.state.okPressed;
    if (
      this.state.totalAmount &&
      this.state.totalAmount.trim().length > 0 &&
      parseFloat(this.state.totalAmount) > 0
    ) {
      this.invoiceData.setRemittanceDetails(this.state);
      this.invoiceData.storeTotalAmount(this.state.totalAmount);
      let token = invData.state.token;
      const searchParams = new URLSearchParams();
      searchParams.append("token", token);
      searchParams.append("amount", this.state.totalAmount);
      if (this.state.emailId == "" || this.state.emailId == undefined) {
        searchParams.append("emailId", "");
      } else {
        searchParams.append("emailId", this.state.emailId);
      }
      searchParams.append("poaCurrency", myGlobals.selectedPoaCurrency);
      if (this.state.customerNumbers != undefined) {
        searchParams.append("customerNumbers", this.state.customerNumbers);
      }

      if (this.state.jobAddress != undefined)
        searchParams.append("jobAddress", this.state.jobAddress);

      if (this.state.referenceNo != undefined)
        searchParams.append("referenceNo", this.state.referenceNo);

      if (this.state.poNumber != undefined)
        searchParams.append("poNumber", this.state.poNumber);

      if (this.state.comments != undefined)
        searchParams.append("comments", this.state.comments);

      if (this.state.quoteNumber != undefined)
        searchParams.append("quoteNumber", this.state.quoteNumber);

      if (this.state.phoneNo != undefined)
        searchParams.append("phoneNo", this.state.phoneNo);

      if (this.state.product != undefined)
        searchParams.append("product", this.state.product);

      if (this.state.invoiceNumber != undefined)
        searchParams.append("invoiceNumber", this.state.invoiceNumber);

      if (this.state.referenceField2 != undefined)
        searchParams.append("referenceField2", this.state.referenceField2);

      if (this.state.referenceField3 != undefined)
        searchParams.append("referenceField3", this.state.referenceField3);

      if (this.state.referenceField4 != undefined)
        searchParams.append("referenceField4", this.state.referenceField4);

      if (this.state.custIdentifier1 != undefined)
        searchParams.append("custIdentifier1", this.state.custIdentifier1);
      
      if (this.state.custIdentifier2 != undefined)
        searchParams.append("custIdentifier2", this.state.custIdentifier2);

      if (this.state.custIdentifier3 != undefined)
        searchParams.append("custIdentifier3", this.state.custIdentifier3);

      if (this.state.custIdentifier4 != undefined)
        searchParams.append("custIdentifier4", this.state.custIdentifier4);

      if (this.state.custIdentifier5 != undefined)
        searchParams.append("custIdentifier5", this.state.custIdentifier5);

      console.log(searchParams)
      let link = "topBuildRemittanceDetails";
      let res;
      link = myGlobals.initialHost + myGlobals.appender + link;
      fetch(link, {
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          return response.json();
        })
        .then(function (data) {
          //console.log(data);

          if (
            data.rows.isRequiredFieldValidationFailed !== undefined &&
            data.rows.isRequiredFieldValidationFailed
          ) {
            let additionalItems = [];

            for (let i = 0; i < data.rows.names.length; ++i)
              additionalItems.push(
                myGlobals.injectProp.formatMessage({
                  id: "dynamicform." + data.rows.names[i],
                  defaultMessage: data.rows.displayNames[i],
                })
              );

            callReduxAlertAction(
              "Alert.RequiredFieldsMissing",
              "Please enter the following required fields",
              additionalItems
            );
            return;
          }

          if (
            !data.rows.disableCustomerValidation &&
            document.getElementsByName("customerNumbers").length > 0 &&
            (data.rows.isValidEmailId || data.rows.isValidEmailId == undefined)
          ) {
            if (data.rows.customerCount == 0) {
              if (
                data.rows.customerNumbers == null ||
                data.rows.customerNumbers.trim() == "" ||
                data.rows.customerNumbers.indexOf(",") >= 0
              ) {
                if (!isOkPressed)
                  callReduxConfirmAlertAction(
                    "generic.pte.cashCustomer",
                    "Proceeding with payment on cash customer"
                  );
              } else {
                if (!isOkPressed)
                  callReduxConfirmAlertAction(
                    "generic.pte.noExactCashCustomer",
                    "Exact customer not found. Proceeding with payment on cash customer"
                  );
              }
              if (isOkPressed) {
                onSuccess(data, invData);
              } else {
                return false;
              }
            } else if (data.rows.customerCount == 1) {
              if (!isOkPressed)
                callReduxConfirmAlertAction(
                  "generic.pte.resolvedCustomer",
                  "Proceeding with payment on customer# ",
                  data.rows.customerNumbers
                );
              if (isOkPressed) {
                onSuccess(data, invData);
              } else {
                return false;
              }
            } else {
              callReduxAlertAction(
                "generic.pte.multipleCustomers",
                "Customer number matches with multiple customers. Please provide unique customer numbers to proceed."
              );
              return false;
            }
          } else {
            onSuccess(data, invData);
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          callReduxAlertAction(
            "failure.generic.remittance.alert",
            "Validations failed, please enter correct data"
          );
        });
    }
  };

  onAlertConfirmDialogPress = () => {
    this.setState({
      okPressed: true,
    });
    reduxStore.dispatch(hideConfirmAlertAction());
  };

  setInvoiceData = (data) => {
    this.invoiceData = data;
  };
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <>
	       <MarketingText
	          textId="Header.MarketingText.POA"
	          defaultMessage="View Invoices and Make Payments Online"
	        />
            <AlertConfirmDialog
              onAlertConfirmDialogClick={this.onAlertConfirmDialogPress}
            />
            <Container className="form-content">
              {this.setInvoiceData(data)}
              <Row>
                <Col className="center-element bold">
                {myUtilities.accountSpecificLanguage(
                        "generic.poa.Heading",
                        "Enter Remittance Details def"
                      )}
                </Col>
              </Row>
              <form
                action="javascript:void(0);"
                onSubmit={() => this.onSubmit(data, this.responseHandler)}
              >
                {this.dynamicForm()}
                {this.alertContent()}
                <Row className="topbuild-row-margin-top">
                  <Col sm={5} />
                  <Col sm={2}>
                        <input
                          type="submit"
                          value={myUtilities.accountSpecificLanguage("submit", "Submit")}
                          className="topbuild-submit-button topbuild-submit-button2 static-poa-button"
                        />
                  </Col>
                  <Col sm={5} />
                </Row>
              </form>
            </Container>
          </>
        )}
      </Subscribe>
    );
  }
  componentDidMount() {
    this.getDynamicFieldData(
      this.invoiceData,
      this.dynamicFieldsResponseHandler
    );
  }
  componentDidUpdate(prevProps, nextProps) {
    if (!nextProps.okPressed && this.state.okPressed)
      this.onSubmit(this.invoiceData, this.responseHandler);
  }
}
export default TopBuildPaymentOnAccountForm;
